/**
 * Mobile Menu Drawer V2 (tabs inside default Shopify header-drawer)
 * - Uses the theme's built-in header-drawer/menu-drawer open/close
 * - Only handles tab switching + mobile bottom nav actions
 */

(function () {
  function initMenuDrawerV2() {
    const headerDrawer = document.querySelector('header-drawer[data-menu-v2-drawer]');
    if (!headerDrawer) return;

    const details = headerDrawer.querySelector('#Details-menu-drawer-container');
    const summary = details?.querySelector('summary');
    const tabs = headerDrawer.querySelectorAll('.menu-drawer-v2__tab[data-tab]');

    const bottomNav = document.querySelector('[data-menu-v2-bottom-nav]');
    const bottomNavButtons = bottomNav?.querySelectorAll('[data-menu-v2-action]');
    const bottomCartPill = document.querySelector('[data-bottom-cart-pill]');
    const bottomCartTotal = bottomCartPill?.querySelector('[data-bottom-cart-total]');
    const bottomCartIconEmpty = bottomCartPill?.querySelector('[data-cart-icon-empty]');
    const bottomCartIconFull = bottomCartPill?.querySelector('[data-cart-icon-full]');
    const bottomCartIconBtn = document.querySelector('[data-bottom-cart-icon]');
    const bottomCartBadge = bottomCartIconBtn?.querySelector('[data-bottom-cart-badge]');

    if (!details || !summary || !tabs?.length) return;

    let pendingTab = null;

    function setBottomActive(tabName) {
      if (!bottomNavButtons?.length) return;
      bottomNavButtons.forEach((btn) => {
        const isActive = btn.dataset.menuV2Action === tabName;
        btn.classList.toggle('active', isActive);
      });
    }

    function showTab(tabName) {
      tabs.forEach((tab) => {
        const isTarget = tab.dataset.tab === tabName;
        tab.toggleAttribute('hidden', !isTarget);
      });

      if (tabName === 'catalog' || tabName === 'search') {
        setBottomActive(tabName);
      } else {
        setBottomActive(null);
      }
    }

    function formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      const value = Number(cents);
      if (!Number.isFinite(value)) return '';

      const moneyFormat = format || bottomCartPill?.dataset.moneyFormat || '${{amount}}';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const match = moneyFormat.match(placeholderRegex);
      const placeholder = match ? match[1] : 'amount';

      function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        const n = Number(number);
        if (!Number.isFinite(n)) return '0';
        const fixed = (n / 100).toFixed(precision);
        const parts = fixed.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
        const centsPart = parts[1] ? `${decimal}${parts[1]}` : '';
        return `${dollars}${centsPart}`;
      }

      let formattedValue = '';
      switch (placeholder) {
        case 'amount':
          formattedValue = formatWithDelimiters(value, 2, ',', '.');
          break;
        case 'amount_no_decimals':
          formattedValue = formatWithDelimiters(value, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          formattedValue = formatWithDelimiters(value, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          formattedValue = formatWithDelimiters(value, 0, '.', ',');
          break;
        default:
          formattedValue = formatWithDelimiters(value, 2, ',', '.');
      }

      return moneyFormat.replace(placeholderRegex, formattedValue);
    }

    function updateBottomCart(cartData) {
      if (!cartData) return;

      const itemCount = Number(cartData.item_count || 0);
      
      // Вычисляем total без упаковки
      let packagingCost = 0;
      if (window.PackagingUtils && cartData.items) {
        const config = window.PackagingUtils.getConfig();
        if (config && config.frozenId && config.cooledId) {
          const frozenId = String(config.frozenId);
          const cooledId = String(config.cooledId);
          
          cartData.items.forEach(item => {
            const variantId = String(item.variant_id || item.id);
            if (variantId === frozenId || variantId === cooledId) {
              packagingCost += item.final_line_price || 0;
            }
          });
        }
      }
      
      const totalPrice = Number(cartData.total_price || 0) - packagingCost;

      if (bottomCartPill && bottomCartTotal) {
        bottomCartTotal.textContent = formatMoney(totalPrice, bottomCartPill.dataset.moneyFormat);
      }

      if (bottomCartIconEmpty && bottomCartIconFull) {
        bottomCartIconEmpty.toggleAttribute('hidden', itemCount > 0);
        bottomCartIconFull.toggleAttribute('hidden', itemCount === 0);
      }

      // Tablet cart icon badge
      if (bottomCartBadge) {
        bottomCartBadge.textContent = itemCount > 0 ? String(itemCount) : '';
        bottomCartBadge.toggleAttribute('hidden', itemCount === 0);
      }
    }

    // Open/close lifecycle
    details.addEventListener('toggle', () => {
      if (details.hasAttribute('open')) {
        // Показываем хедер при открытии меню (в т.ч. при открытии по кнопкам нижнего меню после проскролла)
        revealHeader();
        // Burger open всегда -> Menu (если открывали не через нижнюю панель)
        const tabToShow = pendingTab || 'menu';
        showTab(tabToShow);
        pendingTab = null;
        return;
      }

      // Closed
      pendingTab = null;
      setBottomActive(null);
    });

    // Хедер всегда fixed — revealHeader больше не нужен
    function revealHeader() {}

    // Bottom nav actions (mobile)
    if (bottomNavButtons?.length) {
      bottomNavButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          const action = btn.dataset.menuV2Action;
          if (!action) return;

          // Catalog/Search -> open menu + switch tab
          if (action === 'catalog' || action === 'search') {
            e.preventDefault();

            // Показываем хедер если он скрыт
            revealHeader();

            if (!details.hasAttribute('open')) {
              pendingTab = action;
              summary.click();
              return;
            }

            showTab(action);
            return;
          }

          // Cart -> do exactly what header cart does (ALWAYS open drawer, never go to /cart page)
          if (action === 'cart') {
            e.preventDefault();

            const cartBubble = document.querySelector('#cart-icon-bubble');

            // If menu is open, close it first so cart drawer/page behaves like header click
            if (details.hasAttribute('open')) summary.click();

            window.setTimeout(() => {
              if (cartBubble) {
                cartBubble.click();
              } else {
                // Fallback: try to open cart-drawer directly
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer && typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                }
              }
            }, 0);
          }
        });
      });
    }

    // Ensure initial state
    showTab('menu');

    // Keep bottom cart pill in sync with cart updates across the theme
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cartData = event?.cartData;
        if (!cartData) return;
        updateBottomCart(cartData);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuDrawerV2);
  } else {
    initMenuDrawerV2();
  }
})();
